// extracted by mini-css-extract-plugin
export default {"MilestoneFilterItem":"ItemPickerMilestone-module__MilestoneFilterItem__fydVvrF","MilestoneItem":"ItemPickerMilestone-module__MilestoneItem__BbdPNMO"};